import { FormBaseDialog } from "components/parts/dialogs";
import { Button } from "@mui/material";

import { FormProvider, useForm } from "react-hook-form";
import { TextField, DialogContent, DialogActions, Stack } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormInput } from "components/parts/form";
import { useEffect } from "react";
import { useI18n } from "i18n";

import { IBeaconSchema, beaconSchema, clearData } from "./hooks/schemas";

type IStudent = {
  id: number;
  lastName: string;
  firstName: string;
  gradeName: string;
  sectionName: string;
};

const BeaconManageDialog = (props) => {
  const { open, editType, editData, handleClose, handleSubmit } = props;
  const { t } = useI18n();

  const methods = useForm<IBeaconSchema>({
    resolver: yupResolver(beaconSchema),
    defaultValues: clearData,
  });

  const { handleSubmit: formSubmit, reset, clearErrors } = methods;

  const onClose = () => {
    if (handleClose) {
      handleClose();
      clearErrors();
      reset(clearData);
    }
  };

  const onSubmit = async (data) => {
    const { studentId, id: beaconId } = editData;
    if (handleSubmit) {
      const resultSubmit = await handleSubmit(studentId, beaconId, data);
      if (resultSubmit) {
        handleClose();
        reset(data);
      }
    }
  };

  useEffect(() => {
    if (editData) {
      const data = {
        uuid: editData["uuid"] ? editData["uuid"] : null,
        major: editData["major"] ? editData["major"] : null,
        minor: editData["minor"] ? editData["minor"] : null,
      };
      reset(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editType, editData]);

  return (
    <FormBaseDialog
      open={open}
      handleClose={onClose}
      title={editType === "edit" ? t("beacon.editTitle") : t("beacon.addTitle")}
      content={
        <>
          <FormProvider {...methods}>
            <form onSubmit={formSubmit(onSubmit)}>
              <DialogContent>
                <Stack direction="column" spacing={1}>
                  <FormInput
                    name="uuid"
                    render={(field, fieldState) => {
                      return (
                        <TextField
                          {...field}
                          label={t("beacon.uuid")}
                          type={"text"}
                          error={!!fieldState.error}
                          helperText={fieldState.error?.message}
                          fullWidth
                          margin="dense"
                        />
                      );
                    }}
                  />
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                    <FormInput
                      name="major"
                      render={(field, fieldState) => {
                        return (
                          <TextField
                            {...field}
                            label={t("beacon.major")}
                            type={"text"}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            fullWidth
                            margin="dense"
                          />
                        );
                      }}
                    />

                    <FormInput
                      name="minor"
                      render={(field, fieldState) => {
                        return (
                          <TextField
                            {...field}
                            label={t("beacon.minor")}
                            type={"text"}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            fullWidth
                            margin="dense"
                          />
                        );
                      }}
                    />
                  </Stack>
                </Stack>
              </DialogContent>
              <DialogActions>
                <>
                  <Button
                    onClick={() => {
                      onClose();
                    }}
                    color="primary"
                  >
                    {t("common.cancel")}
                  </Button>
                  <Button type="submit" color="primary">
                    {editType === "edit" ? t("common.update") : t("common.add")}
                  </Button>
                </>
              </DialogActions>
            </form>
          </FormProvider>
        </>
      }
    />
  );
};

export { BeaconManageDialog };
export { CSVImportDialog } from "./CSVImportDialog";
export type { IStudent };
